import React from 'react';
import './ParentScoreItemStatusBlock.scss';
import { useTranslation } from 'react-i18next';

const ParentScoreItemStatusBlock = ({ color, pacing }) => {
  const {t} = useTranslation(['teacher_parent_report']);
  
  return (
    <div className={`__status-block`} style={{
      backgroundColor: color,
    }}>
      {t(pacing)}
    </div>
  )
}

export default ParentScoreItemStatusBlock;